import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Visit", id: "visit" },
  { label: "Book", id: "book" },
  { label: "Menu", id: "menu" },
  { label: "Wine Bar", id: "dine" },
  { label: "Wine Club", id: "wine-club" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#FDFBF7]/90 backdrop-blur-md border-b border-[#E7E5E4] py-3" : "py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <button
          onClick={() => go("top")}
          data-testid="brand-logo"
          className={`font-serif text-xl md:text-2xl font-semibold tracking-tight transition-colors ${
            scrolled ? "text-[#1C1917]" : "text-white"
          }`}
        >
          Gledswood <span className="italic font-normal">Cellar Door</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          <a
            href="https://www.gledswood.com.au"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-home"
            className={`text-sm font-medium tracking-wide transition-colors hover:opacity-70 ${
              scrolled ? "text-[#57534E]" : "text-white/90"
            }`}
          >
            Home
          </a>
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className={`text-sm font-medium tracking-wide transition-colors hover:opacity-70 ${
                scrolled ? "text-[#57534E]" : "text-white/90"
              }`}
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-cta"
            onClick={() => go("book")}
            className="px-5 py-2 rounded-full bg-[#4A5D23] text-white text-sm font-semibold hover:bg-[#3D4D1D] transition-all hover:-translate-y-0.5"
          >
            Book a Tasting
          </button>
        </nav>

        <button
          className={`md:hidden ${scrolled ? "text-[#1C1917]" : "text-white"}`}
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FDFBF7] border-t border-[#E7E5E4] mt-3 px-6 py-4 flex flex-col gap-4">
          <a
            href="https://www.gledswood.com.au"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-mobile-home"
            className="text-left text-[#57534E] font-medium"
          >
            Home
          </a>
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-[#57534E] font-medium"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
